"use client";

import { useLocale } from "@/app/providers/IntlProvider";
import { FormattedMessage, useIntl } from "react-intl";
import { MdLanguage } from "react-icons/md";
import { trackEvent } from "@/app/providers/ObservabilityProvider";

type LanguageSwitcherProps = {
  variant?: "desktop" | "mobile";
  /** Called after the switch, e.g. to close the mobile drawer it sits in. */
  onSwitch?: () => void;
};

export default function LanguageSwitcher({ variant = "desktop", onSwitch }: LanguageSwitcherProps) {
  const { toggleLocale } = useLocale();
  const intl = useIntl();

  if (variant === "mobile") {
    return (
      <button
        onClick={() => { trackEvent("navbar-language-button"); toggleLocale(); onSwitch?.(); }}
        className="flex min-h-11 items-center gap-2 px-5 py-2 rounded-full w-full hover:bg-slate-100 transition-colors duration-300 cursor-pointer"
        aria-label={intl.formatMessage({ id: "a11y.languageSwitch" })}
      >
        <MdLanguage aria-hidden="true" className="text-xl" />
        <span className="uppercase">
          <FormattedMessage id="language.switch" />
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={() => { trackEvent("navbar-language-button"); toggleLocale(); }}
      className="flex items-center gap-1.5 px-4 py-2 rounded-full hover:bg-slate-100 transition-colors duration-300 cursor-pointer text-slate-800"
      aria-label={intl.formatMessage({ id: "a11y.languageSwitch" })}
    >
      <MdLanguage aria-hidden="true" className="text-lg" />
      <span className="text-sm font-medium">
        <FormattedMessage id="language.switch" />
      </span>
    </button>
  );
}
